<div class="al-page">
  <button class="al-close" *ngIf="!isMandatoryOnboarding" (click)="goDashboard()">
    <i class="fas fa-arrow-left"></i> Back to Dashboard
  </button>

  <div class="al-header">
    <h1 class="al-title">Plans that grow with you</h1>
    <p class="al-subtitle">Unlock advanced marketplace tools, insights, and premium support to scale your business.</p>

    <div class="al-toggle-wrap">
      <div class="al-toggle">
        <button *ngFor="let t of terms" class="al-toggle-btn" [class.active]="selectedTerm.id === t.id"
          (click)="selectTerm(t)">
          {{ t.label }}
          <span class="al-toggle-badge" *ngIf="selectedPlan && getDiscount(selectedPlan, t) > 0">
            -{{ getDiscount(selectedPlan, t) }}%
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- ── Platform-Wide Offer Banner (shown only when superadmin enables it) ── -->
  <div class="al-offer-banner" *ngIf="platformOffer?.enabled">
    <div class="al-offer-inner">
      <div class="al-offer-badge">
        <i class="fas fa-gift"></i>
        {{ platformOffer?.badgeText || 'Limited Offer' }}
      </div>
      <div class="al-offer-text">
        <strong>{{ platformOffer?.highlightText || '3 months free' }}</strong>
        {{ platformOffer?.bodyText || 'on any paid plan' }}
      </div>
      <div class="al-offer-countdown" *ngIf="platformOffer?.countdownLabel || offerExpiryLabel">
        <i class="fas fa-clock"></i>
        {{ offerExpiryLabel || platformOffer?.countdownLabel }}
      </div>
    </div>
  </div>

  <div class="al-cards-wrapper">
    <div class="al-cards">
      <div class="al-card" *ngFor="let p of plans" [class.active]="selectedPlan.id === p.id" [style.--accent]="p.col"
        (click)="selectPlan(p)">

        <div class="al-card-head">
          <div class="al-card-title">
            {{ p.name }}
            <span class="al-card-tag" *ngIf="p.tag">{{ p.tag }}</span>
          </div>
          <div class="al-card-radio">
            <i class="fas fa-circle"></i>
          </div>
        </div>

        <div class="al-card-price">
          <span class="al-price-old" *ngIf="hasDiscount(p) && p.fee > 0">
            AED {{ p.fee }}
          </span>
          <span class="al-price-new" *ngIf="p.fee > 0">
            AED {{ currentMonthlyRate(p) }} <small>/ month</small>
          </span>
          <span class="al-price-new" *ngIf="p.fee === 0">
            Free
          </span>
          <span class="al-discount-label" *ngIf="hasDiscount(p) && p.fee > 0">
            Save {{ currentDiscount(p) }}%
          </span>
        </div>

        <div class="al-card-desc">{{ p.tagline }}</div>

        <div class="al-card-divider"></div>

        <div class="al-card-perks-title">Features included:</div>
        <ul class="al-card-perks">
          <li *ngFor="let perk of getPlanPerks(p)">
            <i class="fas fa-check"></i>
            <span>{{ perk }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="al-compare-wrapper">
      <h2 class="al-compare-title">Compare tiers &amp; features</h2>
      <div class="compare-scroll">
        <div class="compare-section" *ngFor="let sec of featureSections">
          <div class="compare-row compare-head">
            <div class="compare-cell compare-cell--title">
              <i class="fas" [ngClass]="sec.icon"></i> {{ sec.title }}
            </div>
            <div class="compare-cell compare-cell--plan" *ngFor="let p of plans">
              {{ p.name }}
            </div>
          </div>
          <div class="compare-row" *ngFor="let row of sec.rows">
            <div class="compare-cell compare-cell--feature">
              {{ row.label }}
              <i class="fas fa-circle-info tooltip-icon" *ngIf="row.tooltip" [title]="row.tooltip"></i>
            </div>
            <div class="compare-cell compare-cell--value" *ngFor="let p of plans">
              <ng-container *ngIf="isBoolean(cellValue(row, p.id))">
                <i class="fas fa-check text-green" *ngIf="cellValue(row, p.id) === true"></i>
                <i class="fas fa-minus text-gray" *ngIf="cellValue(row, p.id) === false"></i>
              </ng-container>
              <span *ngIf="!isBoolean(cellValue(row, p.id))" class="text-val">
                {{ cellValue(row, p.id) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="al-bottom-bar">
      <div class="al-bottom-inner">
        <div class="al-bottom-left">
          <div class="al-bottom-plan">
            <i class="fas" [ngClass]="selectedPlan.icon" [style.color]="selectedPlan.col"></i>
            {{ selectedPlan.name }} Plan
          </div>
          <div class="al-bottom-price">
            <span class="al-old" *ngIf="selectedPlan && hasDiscount(selectedPlan)">
              AED {{ selectedPlan.fee }}
            </span>
            <span class="al-new" *ngIf="selectedPlan && selectedPlan.fee > 0">
              AED {{ currentMonthlyRate(selectedPlan) }} <small>/ month</small>
            </span>
            <span class="al-new" *ngIf="selectedPlan.fee === 0">Free forever</span>
          </div>
          <div class="al-bottom-sub">
            <ng-container *ngIf="selectedPlan && selectedPlan.fee > 0">
              Billed AED {{ calcTotal() }} for {{ selectedTerm.months }} months
              <span *ngIf="hasDiscount(selectedPlan)">
                · Save {{ currentDiscount(selectedPlan) }}% vs monthly
              </span>
            </ng-container>
            <ng-container *ngIf="selectedPlan && selectedPlan.fee === 0">
              No credit card required.
            </ng-container>
          </div>
        </div>
        <div class="al-bottom-right">
          <button class="al-btn-subscribe" (click)="openPaymentModal()" [disabled]="isFreePlanActivating || modalInitializing">
            <ng-container *ngIf="!isFreePlanActivating">
              Subscribe &amp; Pay <i class="fas fa-arrow-right"></i>
            </ng-container>
            <ng-container *ngIf="isFreePlanActivating">
              <i class="fas fa-spinner fa-spin"></i> Activating...
            </ng-container>
          </button>
          <div class="al-bottom-terms">
            By subscribing, you agree to our Purchaser Terms.<br>Cancel anytime.
          </div>
          <!-- Error shown inline when free plan activation fails -->
          <div class="al-bottom-error" *ngIf="paymentError && selectedPlan.fee === 0">
            <i class="fas fa-exclamation-circle"></i> {{ paymentError }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Payment Modal ───────────────────────────────────── -->
  <div class="pm-overlay" *ngIf="showPaymentModal" (click)="closePaymentModal()">
    <div class="pm-modal" (click)="$event.stopPropagation()">

      <!-- ── Initializing: shown while createCheckoutIntent is running ── -->
      <!-- The Pay button does not exist yet at this point, so the user      -->
      <!-- physically cannot submit payment before a valid intent is ready.  -->
      <div class="pm-initializing" *ngIf="modalInitializing">
        <div class="pm-spinner"></div>
        <p>Preparing secure payment…</p>
      </div>

      <!-- ── Success State (covers both immediate & scheduled) ── -->
      <div class="pm-success" *ngIf="!modalInitializing && paymentSuccess">
        <div class="pm-success-icon">
          <i class="fas fa-check"></i>
        </div>

        <!-- Immediate activation: Free → Paid -->
        <ng-container *ngIf="isImmediateActivation">
          <h3>Plan Activated!</h3>
          <p>Your <strong>{{ selectedPlan.name }}</strong> plan is now active.</p>
        </ng-container>

        <!-- Scheduled upgrade: Paid → Higher Paid -->
        <ng-container *ngIf="!isImmediateActivation">
          <h3>Payment Successful!</h3>
          <p>
            Your <strong>{{ selectedPlan.name }}</strong> plan will activate on
            <strong>{{ upgradeDate }}</strong>
            at the end of your current billing cycle.
          </p>
          <p class="pm-scheduled-note">
            <i class="fas fa-info-circle"></i>
            Your current plan remains active until then. The upgrade applies automatically.
          </p>
        </ng-container>
      </div>

      <!-- ── Payment Form ──────────────────────────────────── -->
      <ng-container *ngIf="!modalInitializing && !paymentSuccess">

        <div class="pm-header">
          <div class="pm-header-left">
            <h3>Complete your subscription</h3>
            <p>Secure payment powered by Stripe</p>
          </div>
          <button class="pm-close" (click)="closePaymentModal()">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="pm-summary">
          <div class="pm-summary-row">
            <span>Plan</span>
            <strong>{{ selectedPlan.name }}</strong>
          </div>
          <div class="pm-summary-row">
            <span>Billing</span>
            <strong>{{ selectedTerm.label }}</strong>
          </div>
          <div class="pm-summary-row" *ngIf="selectedPlan && hasDiscount(selectedPlan)">
            <span>Discount</span>
            <strong class="pm-discount">{{ currentDiscount(selectedPlan) }}% off</strong>
          </div>
          <div class="pm-summary-divider"></div>
          <div class="pm-summary-row pm-summary-total">
            <span>Total due today</span>
            <strong>AED {{ calcTotal() }}</strong>
          </div>
        </div>

        <div class="pm-card-section">
          <label class="pm-label">Card details</label>
          <div class="pm-card-wrap">
            <div id="stripe-card-element"></div>
          </div>
          <p class="pm-card-note">
            <i class="fas fa-lock"></i>
            Your card details are encrypted and never stored on our servers.
          </p>
        </div>

        <div class="pm-error" *ngIf="paymentError">
          <i class="fas fa-exclamation-circle"></i>
          {{ paymentError }}
        </div>

        <button class="pm-pay-btn" (click)="pay()" [disabled]="isPaymentProcessing || isPlanPaymentLocked">
          <ng-container *ngIf="!isPaymentProcessing">
            <i class="fas fa-lock"></i>
            Pay AED {{ calcTotal() }}
          </ng-container>
          <ng-container *ngIf="isPaymentProcessing">
            <i class="fas fa-spinner fa-spin"></i>
            Processing…
          </ng-container>
        </button>
        <p class="pm-terms">
          By paying you agree to our Terms of Service. Cancel anytime.
        </p>

      </ng-container>
    </div>
  </div>

  <!-- ── Free Trial Welcome Modal ────────────────────────── -->
  <div class="pm-overlay" *ngIf="showFreeTrialWelcomeModal">
    <div class="pm-modal trial-modal" (click)="$event.stopPropagation()">
      <div class="pm-success-icon trial-icon">
        <i class="fas fa-gift"></i>
      </div>
      
      <h2 class="trial-title">Start your 3-Month Free Trial!</h2>
      <p class="trial-subtitle">
        Welcome to Aluguloo. Get full, unlimited access to our marketplace and all premium features completely free for 90 days.
      </p>

      <div class="trial-features">
        <div class="trial-feature-item">
          <i class="fas fa-circle-check"></i>
          <span><strong>Unlimited</strong> marketplace listings</span>
        </div>
        <div class="trial-feature-item">
          <i class="fas fa-circle-check"></i>
          <span><strong>Zero</strong> listing fees per vehicle</span>
        </div>
        <div class="trial-feature-item">
          <i class="fas fa-circle-check"></i>
          <span><strong>Unlimited</strong> manual bookings</span>
        </div>
        <div class="trial-feature-item">
          <i class="fas fa-circle-check"></i>
          <span>Premium dashboard & analytics tools</span>
        </div>
      </div>

      <div class="pm-error" *ngIf="paymentError">
        <i class="fas fa-exclamation-circle"></i>
        {{ paymentError }}
      </div>

      <button class="pm-pay-btn trial-btn" (click)="activateFreeTrial()" [disabled]="isFreePlanActivating">
        <ng-container *ngIf="!isFreePlanActivating">
          Start Free Trial
        </ng-container>
        <ng-container *ngIf="isFreePlanActivating">
          <i class="fas fa-spinner fa-spin"></i> Activating...
        </ng-container>
      </button>

      <p class="trial-note">No credit card required. Cancel or upgrade anytime.</p>
    </div>
  <!-- ── Free Plan Success Overlay/Modal ───────────────────── -->
  <div class="pm-overlay success-overlay" *ngIf="showFreePlanSuccessModal">
    <div class="pm-modal success-pop-modal">
      <div class="welcome-badge-wrapper">
        <div class="pulse-ring"></div>
        <div class="pulse-ring delay-1"></div>
        <div class="welcome-badge">
          <i class="fas fa-handshake"></i>
        </div>
      </div>
      <h2 class="welcome-title">WELCOME TO ALUGULOO</h2>
      <p class="pop-success-subtitle">
        Your <strong>{{ activatedFreePlanName }}</strong> is now active.
      </p>
      
      <div class="progress-bar-wrap">
        <div class="progress-bar-fill"></div>
      </div>
      
      <div class="pop-redirect-spinner">
        Preparing your premium workspace...
      </div>
    </div>
  </div>

</div>